<div class="thematics-list-container">
  <wlm-drag-list-custom
    *ngIf="mapLegendItems?.length"
    class="drag-list nested-drag-container drag-container-single"
    [objectsToOrder]="mapLegendItems"
    [settings]="settingsCustom"
    [previewItemClass]="'nested-drag-container'"
  >
    <ng-template let-rowDetail let-isLastItem="isLastItem" #card>
      <div class="thematic-info">
        <ct-map-legend-item [mapLegendItem]="rowDetail"></ct-map-legend-item>
      </div>
    </ng-template>
  </wlm-drag-list-custom>
</div>
